<template>
	<div class="reset-password">
		<div class="page-container">
			<h1 class="reset-password__title">You need to create your password</h1>
			<form class="reset-password__container" v-on:submit="resetPassword">
				<text-field class="reset-password__email" label="Enter your email" type="text" name="email" placeholder="test@test.co.uk" v-model="email" />
				<submit-field class="reset-password__submit">
					<span>Create Password</span>
				</submit-field>
			</form>
		</div>
	</div>
</template>

<script>
import TextField from '../atoms/TextField'
import SubmitField from '../atoms/SubmitField'

export default {
	name: 'SetPassword',
	components: {
		TextField,
		SubmitField,
	},
	data () {
		return {
			email: '',
		}
	},
	created: function ()
	{
		var self = this;
		self.$root.$data.appLoading = false;
	},
	methods: {
		resetPassword(event)
		{
			var self = this;
			event.preventDefault();

			self.$api.triggerForgottenPasswordByEmail(self.email).then((success) => {
				self.$alert.success({ message: "Reset password email sent" });
			}).catch((error) => {
				self.$alert.danger({ message: error.message });
			});

		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".reset-password";
	#{$c}
	{
		background-color: #F4F4F4;
		padding: { top: rem(192); bottom: rem(160); }
		text-align: center;

		&__container
		{
			max-width: 416px;
			@include extend(block-center);
			@include extend(bgc-pal--white);
			border: 1px solid palette('divider');
			padding: rem(48) rem(36);
			text-align: left;
		}

		&__title
		{
			@include extend(h3);
			margin-bottom: rem(48);
		}

		&__email
		{
			margin-bottom: rem(48);
		}

		&__submit
		{
			text-align: center;

			.field__element
			{
				width: 100%;
				max-width: 216px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/admin/ResetPassword.vue